import { useParams } from 'react-router';
import { LegacyCard, Page, Button, Select, TextField, LegacyStack, LegacyCard as Card } from '@shopify/polaris';
import { useContext, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import ListLeads from '../../UI/Leads/ListLeads';
import { NewLeadModal } from '../../UI/Leads/NewLeadModal';
import { postLead, getLeadsExcel, getLeadCenters } from '../../../services/leadsService';
import { checkPermission } from '../../../services/permissionsService';
import { triggerBlobDownload } from '../Reports/efficacy/downloads';

const genderFilterOptions = [
  { label: 'Todos los géneros', value: '' },
  { label: 'Caballero', value: 'Caballero' },
  { label: 'Dama', value: 'Dama' },
  { label: 'Ambos (sin preferencia)', value: 'Ambos' },
];

const Leads = () => {
  const { page } = useParams();
  const [, dispatchToast] = useContext(ToastContext);
  const listLeads = useRef();

  const [interestGender, setInterestGender] = useState('');
  const [depositId, setDepositId] = useState('');
  const [q, setQ] = useState('');
  const [appliedQ, setAppliedQ] = useState('');
  const [downloading, setDownloading] = useState(false);

  // Centros disponibles para el filtro de listado, cacheados.
  const { data: centers = [] } = useQuery(
    ['leadCenters'],
    () => getLeadCenters().then(({ data }) => data.centers || []),
    { staleTime: 1000 * 60 * 60 },
  );
  const centerFilterOptions = [
    { label: 'Todos los centros', value: '' },
    ...centers.map((c) => ({ value: String(c.id), label: `${c.name} (${c.code})` })),
  ];

  // Sólo enviamos al back los filtros con valor.
  const activeFilters = {
    ...(interestGender ? { interestGender } : {}),
    ...(depositId ? { depositId } : {}),
    ...(appliedQ ? { q: appliedQ } : {}),
  };

  const createNewLead = (form) => {
    return postLead(form)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        listLeads.current.last({ new: true });
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
        throw new Error(e.response.data);
      });
  };

  const handleExport = async () => {
    setDownloading(true);
    dispatchToast({ type: SET_OK, payload: { message: 'Generando export, puede tardar' } });
    try {
      const resp = await getLeadsExcel(activeFilters);
      triggerBlobDownload(resp.data, `leads_${new Date().toISOString().slice(0, 10)}.xlsx`);
      dispatchToast({ type: SET_OK, payload: { message: 'Export generado' } });
    } catch (e) {
      dispatchToast({
        type: SET_ERROR,
        payload: { message: e?.response?.data?.message || 'Error generando el export' },
      });
    } finally {
      setDownloading(false);
    }
  };

  const secondaryActions = checkPermission('LEAD:REPORTS')
    ? [{ content: 'Exportar a Excel', onAction: handleExport, loading: downloading }]
    : undefined;

  return (
    <Page
      title="Contactos"
      subtitle="Captación de clientes potenciales"
      primaryAction={checkPermission('LEAD:CREATE') && <NewLeadModal onAddLead={(e) => createNewLead(e)} />}
      secondaryActions={secondaryActions}
      divider
    >
      <Card>
        <Card.Section>
          <LegacyStack alignment="trailing" spacing="tight">
            <LegacyStack.Item>
              <Select
                label="Género"
                options={genderFilterOptions}
                value={interestGender}
                onChange={setInterestGender}
              />
            </LegacyStack.Item>
            <LegacyStack.Item>
              <Select label="Centro" options={centerFilterOptions} value={depositId} onChange={setDepositId} />
            </LegacyStack.Item>
            <LegacyStack.Item fill>
              <TextField
                label="Buscar"
                value={q}
                onChange={setQ}
                placeholder="Nombre, email o teléfono"
                autoComplete="off"
                onBlur={() => setAppliedQ(q)}
                connectedRight={<Button onClick={() => setAppliedQ(q)}>Buscar</Button>}
              />
            </LegacyStack.Item>
          </LegacyStack>
        </Card.Section>
      </Card>

      <LegacyCard>
        <ListLeads ref={listLeads} page={page || 1} filters={activeFilters} />
      </LegacyCard>
    </Page>
  );
};

export default Leads;
